<template>
    <div>
      <div class="loading-spinner-outer" v-if="saving">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Saving, please wait
          </div>
        </div>
      </div>
        <div class="box">
            <div class="box-content">
              <div class="flex-2xs">
                <div class="half-width-2xs pr-3-2xs">
                  <div class="form-group">
                    <label>Address Line 1</label>
                    <input type="text" name="line_1" v-model="showroom.line_1" class="form-control" required>
                  </div>
                  <div class="form-group">
                    <label>Address Line 2</label>
                    <input type="text" name="line_2" v-model="showroom.line_2" class="form-control">
                  </div>
                  <div class="form-group">
                    <label>Town</label>
                    <input type="text" name="town" v-model="showroom.town" class="form-control">
                  </div>
                  <div class="form-group">
                    <label>County</label>
                    <input type="text" name="county" v-model="showroom.county" class="form-control">
                  </div>
                  <div class="form-group">
                    <label>Postcode</label>
                    <input type="text" name="postcode" v-model="showroom.postcode" class="form-control" required>
                  </div>
                </div>
                <div class="half-width-2xs pl-3-2xs">
                  <div class="form-group">
                    <label>
                      <strong> Which products are in this showroom? </strong>
                    </label>
                    <div class="checkboxes" v-for="epwin_system_type in system_types_for_showroom">
                      <label class="checkbox">
                        <input type="checkbox" v-model="epwin_system_type.active">
                        <span class="checkbox-label"> {{ epwin_system_type.label }} </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
                <div class="align-right">
                  <a class="btn-primary" @click.stop.prevent="save()">
                    Update Showroom
                  </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    props: [
      'company',
      'prop_showroom',
      'logged_in_user',
      'system_types_for_showroom',
    ],
    data() {
      return {
        saving: false,
        showroom: {
          epwin_system_types: [],
        },
      }
    },
    mounted() {
      this.showroom = this.prop_showroom;
      this.showroom.epwin_system_types = this.system_types_for_showroom;
    },
    methods: {
      save() {

        const validationErrors = Validate({
          line_1: this.showroom.line_1,
          town: this.showroom.town,
          county: this.showroom.county,
          postcode: this.showroom.postcode,
        }, {
          line_1: {
            presence: {
              allowEmpty: false,
            },
          },
          town: {
            presence: {
              allowEmpty: false,
            },
          },
          county: {
            presence: {
              allowEmpty: false,
            },
          },
          postcode: {
            presence: {
              allowEmpty: false,
            },
          },
        });

        if (validationErrors) {
          Swal.fire({
            title: 'Unable to save showroom',
            icon: 'error',
            html: `<div class="mb-3">${Object.values(validationErrors).join('</div><div class="mb-3">')}</div>`,
          });
          return;
        }

        this.saving = true;

        axios.get(`https://api.postcodes.io/postcodes/${this.showroom.postcode}`).then((response) => {

          if(response.data.result.hasOwnProperty('northings')) {
            this.showroom.northings = response.data.result.northings;
          } else {
            this.showroom.northings = 20;
          }

          if(response.data.result.hasOwnProperty('eastings')) {
            this.showroom.eastings = response.data.result.eastings;
          } else {
            this.showroom.eastings = 20;
          }

          if(response.data.result.hasOwnProperty('postcode')) {
            this.showroom.postcode = response.data.result.postcode;
          }

          this.saveShowroom();

        }).catch(() => {
          this.saving = false;
          Swal.fire({
            title: 'Invalid Postcode',
            icon: 'warning',
          });
        });
      },
      saveShowroom(){
        axios.post(`/company/update-showroom`, {
          company_id: this.company.id,
          showroom: this.showroom,
        }).then((response) => {

          this.saving = false;

          Swal.fire({
            title: 'Showroom Updated',
            icon: 'success',
          });

        });
      }
    },
  };
</script>
